import React from 'react';
import StandardPageTemplate from '../templates/StandardPage';

const SupportPage = (): JSX.Element => {
  return (
    <StandardPageTemplate>
      <h1 className="f-normal f-italic f-serif">
        Support Information
      </h1>
      <p>
        For immediate support, contact your dedicated RVP. You may also email info@lightbeamhealth.com or call (972) 831-7270.
      </p>
    </StandardPageTemplate>
  );
};

export default SupportPage;
